var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 22,
    viewBox: "0 0 126 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L13.4697 7.60081H21.4616L14.996 12.2984L17.4656 19.8992L11 15.2016L4.53436 19.8992L7.00402 12.2984L0.538379 7.60081H8.53035L11 0Z",
    fill: "#FFD233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 0L39.4697 7.60081H47.4616L40.996 12.2984L43.4656 19.8992L37 15.2016L30.5344 19.8992L33.004 12.2984L26.5384 7.60081H34.5303L37 0Z",
    fill: "#FFD233"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0L65.4697 7.60081H73.4616L66.996 12.2984L69.4656 19.8992L63 15.2016L56.5344 19.8992L59.004 12.2984L52.5384 7.60081H60.5303L63 0Z",
    fill: "#FFD233"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89 0L91.4697 7.60081H99.4616L92.996 12.2984L95.4656 19.8992L89 15.2016L82.5344 19.8992L85.004 12.2984L78.5384 7.60081H86.5303L89 0Z",
    fill: "#FFD233"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 0L117.47 7.60081H125.462L118.996 12.2984L121.466 19.8992L115 15.2016L108.534 19.8992L111.004 12.2984L104.538 7.60081H112.53L115 0Z",
    fill: "#FFD233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.739cd13edd23baacb1c30b61ff1b710c.svg";
export { ForwardRef as ReactComponent };